import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEO/SEOHead';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => (
  <main className="page-content not-found-page">
    <SEOHead
      title="Page not found"
      description="This page is not available on the Carmen Lorraine Photography website."
      canonicalUrl="https://carmenlorraine.com/404"
      noIndex={true}
    />
    <div className="not-found-inner">
      <h1>Page not found</h1>
      <p>This address does not match a page on the site.</p>
      <p>The galleries, services, and contact page are available from here.</p>
      <nav className="not-found-links" aria-label="Continue on the site">
        <Link to="/galleries">Galleries</Link>
        <Link to="/services">Services</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/">Homepage</Link>
      </nav>
    </div>
  </main>
);

export default NotFoundPage;
